// extracted by mini-css-extract-plugin
module.exports = {"receipt-list-item-box":"_1Xh_ztWqjwfH-K0ByHCEfI","sales-type-title":"_35mtT_Z30Dmu37bSYc1X7o"};